// extracted by mini-css-extract-plugin
export var acitonButtons = "_36-0";
export var additionalIcon = "_36-f";
export var block = "_36-1";
export var blockContent = "_36-7";
export var blockDescription = "_36-8";
export var blockIcon = "_36-9";
export var blockTitle = "_36-6";
export var border = "_36-a";
export var center = "_36-l";
export var edge = "_36-b";
export var edgeLabel = "_36-c";
export var edgePath = "_36-d";
export var error = "_36-e";
export var flowchart = "_36-g";
export var flowchartContent = "_36-h";
export var highlighted = "_36-3";
export var hover = "_36-4";
export var icon = "_36-i";
export var left = "_36-m";
export var navButton = "_36-j";
export var navButtons = "_36-k";
export var right = "_36-n";
export var selected = "_36-2";
export var small = "_36-5";